import { useEffect, useState } from 'react';
import { findEntityData } from '../../api/apiService';
import horizontalLineSvg from "../../assets/line1.svg";
import verticalLineSvg from "../../assets/line2.svg";

const CoreValues = () => {
    const [section1, setSection1] = useState()
    const findData = async () => {
        const res = await findEntityData('sss_about_core_values')
        setSection1(res?.data?.[0])
    }

    useEffect(() => {
        findData()
    }, [])

    return (
        <div>
            <div className="text-center mb-10">
                <h2
                    className="text-2xl md:text-3xl font-bold text-[#F37934]"
                    data-aos="zoom-in"
                    data-aos-duration="800"
                    data-aos-easing="ease-out"
                >
                    {section1?.heading}
                </h2>
            </div>

            <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 text-left relative pl-0 sm:pl-6 place-items-start sm:place-items-stretch">
                <img
                    src={verticalLineSvg}
                    alt="Vertical line"
                    className="absolute top-0 left-1/2 h-full transform -translate-x-1/2 hidden sm:block"
                />
                {section1?.data?.map((item, index) => (
                    <div key={index} className="p-6">
                        <h3 className="text-[#56453F] font-bold mb-2 flex items-center justify-start">
                            <span className="w-1.5 h-5 bg-[#F37934] mr-2"></span> {item?.heading}
                        </h3>
                        <p className="max-w-xs">{item?.content}</p>
                        <img src={horizontalLineSvg} alt="Horizontal line" className="mt-6 w-full hidden sm:block" />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CoreValues
